import { HttpHeaders } from '@angular/common/http';

export class AppSettings {

   public static API_ENDPOINT='https://api-v2.showmanagementsystem.com/';
   //public static API_ENDPOINT='https://sandbox.showmanagementsystem.com/api/v2/';

//   public static NEW_API_ENDPOINT='http://localhost:5002/';
   public static NEW_API_ENDPOINT='https://ecommerce-api.showmanagementsystem.com/';
   public static AUTH_TOKEN_NAME = 'showmanagementsystem_client_access_token';

   public static APP_VERSION_CHECK_PATH = './assets/version.json';

   public static DEFAULT_HTTP_OPTIONS = {
   	headers: new HttpHeaders({
        'Accept': 'application/json',
      	'Content-Type':  'application/json'})
   };

   public static PUSHER_SETTINGS = {

        key: 'e4635b7106848570e432',
        cluster: 'us2'};

}
